<div class="grid-renderer-editor mm-page">
  <header class="qa-gr-header">
    <div class="qa-gr-title">
      <h2>
        {{_(KEYS.GRID_RENDERER.TITLE)}}
        <span class="qa-gr-unsaved" *ngIf="hasUnsavedChanges">
          <i class="fa fa-circle" aria-hidden="true"></i> {{_(KEYS.GRID_RENDERER.UNSAVED_CHANGES)}}
        </span>
      </h2>
      <p>{{_(KEYS.GRID_RENDERER.SUBTITLE)}}</p>
    </div>
    <div class="qa-gr-actions">
      <button type="button" class="btn btn-outline-secondary" (click)="onLoadDefault()">
        <i class="fa fa-magic" aria-hidden="true"></i> {{_(KEYS.GRID_RENDERER.LOAD_DEFAULT)}}
      </button>
      <button type="button" class="btn btn-outline-secondary" (click)="onReset()" [disabled]="displayFields.length === 0 && detailFields.length === 0">
        <i class="fa fa-undo" aria-hidden="true"></i> {{_(KEYS.GRID_RENDERER.RESET)}}
      </button>
      <button type="button" class="btn btn-primary" (click)="onSave()" [disabled]="!hasUnsavedChanges || isSaving">
        <i class="fa" [ngClass]="isSaving ? 'fa-spinner fa-spin' : 'fa-save'" aria-hidden="true"></i> {{_(KEYS.GRID_RENDERER.SAVE)}}
      </button>
    </div>
  </header>

  <div class="qa-gr-layout">
    <!-- available fields -->
    <aside class="qa-gr-palette">
      <div class="qa-gr-palette-header">{{_(KEYS.GRID_RENDERER.AVAILABLE_FIELDS)}}</div>

      <div class="qa-gr-search">
        <i class="fa fa-search" aria-hidden="true"></i>
        <input type="search" class="form-control" [(ngModel)]="fieldSearchTerm" [placeholder]="_(KEYS.GRID_RENDERER.SEARCH_FIELDS)"
               [attr.aria-label]="_(KEYS.GRID_RENDERER.SEARCH_FIELDS)" autocomplete="off" spellcheck="false">
      </div>

      <div class="qa-gr-palette-scroll">
        <div class="qa-gr-section">
          <div class="qa-gr-section-header"><span class="qa-gr-dot qa-gr-dot-standard"></span>{{_(KEYS.GRID_RENDERER.STANDARD_FIELDS)}}</div>
          <div *ngFor="let def of filteredStandardFields" class="qa-gr-item">
            <span class="qa-gr-item-name">{{_(KEYS.CRUD[def.labelKey] || def.labelKey)}}</span>
            <button type="button" class="qa-gr-add qa-gr-add-display" (click)="addToDisplay(def.key, 'standard')" [attr.title]="_(KEYS.GRID_RENDERER.ADD_TO_DISPLAY)">
              <i class="fa fa-plus" aria-hidden="true"></i> {{_(KEYS.GRID_RENDERER.DISPLAY_FIELD_SHORT)}}
            </button>
            <button type="button" class="qa-gr-add" (click)="addToDetail(def.key, 'standard')" [attr.title]="_(KEYS.GRID_RENDERER.ADD_TO_DETAIL)">
              <i class="fa fa-plus" aria-hidden="true"></i> {{_(KEYS.GRID_RENDERER.DETAIL_LINE_SHORT)}}
            </button>
          </div>
          <div *ngIf="availableStandardFields.length === 0" class="qa-gr-empty">{{_(KEYS.GRID_RENDERER.ALL_STANDARD_PLACED)}}</div>
          <div *ngIf="availableStandardFields.length > 0 && filteredStandardFields.length === 0" class="qa-gr-empty">{{_(KEYS.GRID_RENDERER.NO_SEARCH_RESULTS)}}</div>
        </div>

        <div class="qa-gr-section">
          <div class="qa-gr-section-header"><span class="qa-gr-dot qa-gr-dot-custom"></span>{{_(KEYS.GRID_RENDERER.CUSTOM_FIELDS)}}</div>
          <div *ngFor="let def of filteredCustomFields" class="qa-gr-item">
            <span class="qa-gr-item-name">{{def.label}}</span>
            <button type="button" class="qa-gr-add qa-gr-add-display" (click)="addToDisplay(def.key, 'custom')" [attr.title]="_(KEYS.GRID_RENDERER.ADD_TO_DISPLAY)">
              <i class="fa fa-plus" aria-hidden="true"></i> {{_(KEYS.GRID_RENDERER.DISPLAY_FIELD_SHORT)}}
            </button>
            <button type="button" class="qa-gr-add" (click)="addToDetail(def.key, 'custom')" [attr.title]="_(KEYS.GRID_RENDERER.ADD_TO_DETAIL)">
              <i class="fa fa-plus" aria-hidden="true"></i> {{_(KEYS.GRID_RENDERER.DETAIL_LINE_SHORT)}}
            </button>
          </div>
          <div *ngIf="customDefinitions.length === 0" class="qa-gr-empty">{{_(KEYS.GRID_RENDERER.NO_CUSTOM_FIELDS)}}</div>
          <div *ngIf="customDefinitions.length > 0 && availableCustomFields.length === 0" class="qa-gr-empty">{{_(KEYS.GRID_RENDERER.ALL_CUSTOM_PLACED)}}</div>
          <div *ngIf="availableCustomFields.length > 0 && filteredCustomFields.length === 0" class="qa-gr-empty">{{_(KEYS.GRID_RENDERER.NO_SEARCH_RESULTS)}}</div>
        </div>
      </div>
    </aside>

    <section class="qa-gr-main">
      <!-- preview: the patient column as it appears in the patient list -->
      <div class="qa-gr-card">
        <div class="qa-gr-card-title"><i class="fa fa-eye" aria-hidden="true"></i> {{_(KEYS.GRID_RENDERER.PREVIEW)}}</div>
        <div class="qa-gr-preview">
          <div class="qa-gr-preview-head">{{_(KEYS.GRID_RENDERER.PREVIEW_COLUMN)}}</div>
          <div class="qa-gr-preview-cell">
            <div><a class="badge badge-success preview-link">{{previewDisplayText}}</a></div>
            <div class="qa-gr-preview-detail" *ngIf="previewDetailText">{{previewDetailText}}</div>
          </div>
        </div>
      </div>

      <!-- configuration of both parts of the column -->
      <div class="qa-gr-card">
        <div class="qa-gr-zones">
          <div class="qa-gr-zone">
            <div class="qa-gr-zone-head">
              <span class="qa-gr-zone-icon qa-gr-zone-icon-display"><i class="fa fa-link" aria-hidden="true"></i></span>
              <div>
                <div class="qa-gr-zone-title">{{_(KEYS.GRID_RENDERER.DISPLAY_FIELD)}}</div>
                <div class="qa-gr-zone-desc">{{_(KEYS.GRID_RENDERER.DISPLAY_FIELD_DESC)}}</div>
              </div>
            </div>
            <div class="qa-gr-dropzone drop-zone" [class.qa-gr-dropzone-empty]="displayFields.length === 0"
                 [dragula]="'grid-renderer-display'" [(dragulaModel)]="displayFields">
              <div *ngFor="let entry of displayFields; let i = index" class="placed-field" [ngClass]="'field-type-' + entry.fieldType">
                <span class="drag-handle" [attr.title]="_(KEYS.GRID_RENDERER.REORDER)"><i class="fa fa-bars" aria-hidden="true"></i></span>
                <span class="qa-gr-field-name">{{getFieldLabel(entry)}}</span>
                <input type="text" class="form-control label-input" [placeholder]="_(KEYS.GRID_RENDERER.LABEL_PLACEHOLDER)"
                       [attr.aria-label]="_(KEYS.GRID_RENDERER.LABEL_PLACEHOLDER)"
                       [value]="entry.label || ''" (input)="onDisplayLabelChange(i, $event.target.value)">
                <button type="button" class="qa-gr-remove" (click)="removeFromDisplay(i)"
                        [attr.title]="_(KEYS.GRID_RENDERER.REMOVE)" [attr.aria-label]="_(KEYS.GRID_RENDERER.REMOVE)">
                  <i class="fa fa-times" aria-hidden="true"></i>
                </button>
              </div>
              <div *ngIf="displayFields.length === 0" class="qa-gr-drop-hint">{{_(KEYS.GRID_RENDERER.DROP_HINT)}}</div>
            </div>
          </div>

          <div class="qa-gr-zone">
            <div class="qa-gr-zone-head">
              <span class="qa-gr-zone-icon"><i class="fa fa-align-left" aria-hidden="true"></i></span>
              <div>
                <div class="qa-gr-zone-title">{{_(KEYS.GRID_RENDERER.DETAIL_LINE)}}</div>
                <div class="qa-gr-zone-desc">{{_(KEYS.GRID_RENDERER.DETAIL_LINE_DESC)}}</div>
              </div>
            </div>
            <div class="qa-gr-dropzone drop-zone" [class.qa-gr-dropzone-empty]="detailFields.length === 0"
                 [dragula]="'grid-renderer-detail'" [(dragulaModel)]="detailFields">
              <div *ngFor="let entry of detailFields; let i = index" class="placed-field" [ngClass]="'field-type-' + entry.fieldType">
                <span class="drag-handle" [attr.title]="_(KEYS.GRID_RENDERER.REORDER)"><i class="fa fa-bars" aria-hidden="true"></i></span>
                <span class="qa-gr-field-name">{{getFieldLabel(entry)}}</span>
                <input type="text" class="form-control label-input" [placeholder]="_(KEYS.GRID_RENDERER.LABEL_PLACEHOLDER)"
                       [attr.aria-label]="_(KEYS.GRID_RENDERER.LABEL_PLACEHOLDER)"
                       [value]="entry.label || ''" (input)="onDetailLabelChange(i, $event.target.value)">
                <button type="button" class="qa-gr-remove" (click)="removeFromDetail(i)"
                        [attr.title]="_(KEYS.GRID_RENDERER.REMOVE)" [attr.aria-label]="_(KEYS.GRID_RENDERER.REMOVE)">
                  <i class="fa fa-times" aria-hidden="true"></i>
                </button>
              </div>
              <div *ngIf="detailFields.length === 0" class="qa-gr-drop-hint">{{_(KEYS.GRID_RENDERER.DROP_HINT)}}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
